import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({ title, description, url }) => {
  const siteUrl = "https://www.fsel.com.pk";
  const fullUrl = url ? `${siteUrl}${url}` : siteUrl;
  const pageTitle = title ? `${title} | Foundation Solar Energy` : 'Foundation Solar Energy Limited';
  const pageDescription = description || "Foundation Solar Energy Limited (FSEL) provides top-tier EPC solar energy solutions, hybrid systems, and smart microgrids in Pakistan.";
  const imageUrl = `${siteUrl}/logo192.png`;

  return (
    <Helmet>
      <title>{pageTitle}</title>
      <meta name="description" content={pageDescription} />
      
      <meta property="og:type" content="website" />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:title" content={pageTitle} />
      <meta property="og:description" content={pageDescription} />
      <meta property="og:image" content={imageUrl} />
      
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={fullUrl} />
      <meta name="twitter:title" content={pageTitle} />
      <meta name="twitter:description" content={pageDescription} />
      <meta name="twitter:image" content={imageUrl} />
    </Helmet>
  );
};

export default SEO;
